
import ad from '@/assets/ad.png'
import Loading from 'vux/src/components/loading/index.vue'

import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
  name: 'app',
  directives: {
    
  },
  components: {
    Loading,
    Tabbar,
    TabbarItem,
    Popup,
    XButton
  },
  data(){
    return {
      ad:ad,
      show1:false
    }
  },
  computed: {
    isLoading(){
    	return this.$store.state.isLoading
    }
  },
  created(){
    
  	},
  methods:{
    
  },
  watch: {
    
  }
  }





// WEBPACK FOOTER //
// ./src/App.vue